<!--
 * @Author: dingguowei
 * @Date: 2023-06-13 11:58:08
 * @LastEditors: dingguowei
 * @LastEditTime: 2023-07-05 15:28:20
-->
<!-- 任务大厅任务组件 -->
<template>
  <div>
    <el-card class="hallitem">
      <div class="title">
        <p style="font-size: 0.9rem; font-weight: 600">{{ taskData.title }}</p>
        <p style="font-size: 0.6rem; color: #999999">
          截止时间:{{ taskData.endAt }}
        </p>
      </div>
      <div class="ask">
        <p style="font-size: 0.8rem; font-weight: 600">任务奖励</p>
        <div class="askbody">
          <p>提交任务立得 <span>{{ taskData.downPayment }}</span>元，提交后满 <span>{{ taskData.finalDays }}</span>天再奖励<span>{{
            taskData.finalPayment }}</span>元
          </p>
          <p>互动数满 <span>{{ taskData.salaryListVos[0].totalNum }}</span>奖励 <span>{{
            taskData.salaryListVos[0].salary }}</span></p>
        </div>
      </div>
      <div class="num">
        <span>{{ taskData.receivedNum }}个人参与项目</span>
        <el-button v-if="taskData.userStatus === null" round size="mini"
          style="margin-left: 3rem; background-color: #5874ef; color: #fff" @click="receive(taskData)">
          查看详情
        </el-button>
        <el-button v-else round size="mini" :disabled="true"
          style="margin-left: 3rem; background-color: #999999; color: #fff">
          已领取
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import router from "@/router";
import store from "@/store";
export default {
  props: {
    taskData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      askSetting: [
        {
          name: "互动数",
          fieID: "totalNum",
        },
        {
          name: "点赞数",
          fieID: "likeNum",
        },
        {
          name: "收藏数",
          fieID: "collectNum",
        },
        {
          name: "评论数",
          fieID: "commentNum",
        },
        {
          name: "转发数",
          fieID: "shareNum",
        },
      ],
    };
  },
  created() { },
  mounted() { },
  watch: {},
  computed: {},
  methods: {
    receive(val) {
      store.commit("task/CHANGE_publisherAccount", val.publisherAccount);
      store.commit("task/CHANGE_publisherId", val.publisherId);
      store.commit("task/CHANGE_MISSIONID", val.id);
      store.commit("user/CHANGE_userCurTaskStatus", null);
      router.push({ path: "/userDetails" });
    },
  },
};
</script>
<style lang="scss" scoped>
.hallitem {
  font-family: PingFangSC-Regular, PingFang SC;

  .title {
    line-height: 160%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ask {
    margin-top: 10px;

    .askbody {
      padding: 7px 0;
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      font-size: 0.7rem;

      & span {
        color: red;
        font-weight: bold;
      }
    }
  }

  .num {
    margin-top: 10px;
    display: flex;

    & span {
      padding: 6px 10px;
      display: inline-block;
      flex: 1;
      // width: 14rem;
      font-size: 0.8rem;
      background-color: #f6f6f6;
      border-radius: 1rem;
    }
  }
}
</style>